import React, { memo, useEffect, useRef } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Item = styled.li`
  width: 100%;
  height: 100%;
  display: flex;
  @media (max-width: 48em) {
    justify-content: flex-end !important;
  }
`;

const ItemContainer = styled.div`
  width: 40%;
  height: fit-content;
  padding: 1rem;
  border: 3px solid ${(props) => props.theme.text};
  box-shadow: ${({ isActive }) => (isActive ? '0px 8px 24px rgba(0, 0, 0, 0.5)' : 'none')};
  transition: box-shadow 0.3s ease-in-out;

  @media (max-width: 48em) {
    width: 70%;
  }
`;

const Box = styled.p`
  height: fit-content;
  background-color: ${(props) => props.theme.carouselColor};
  color: ${(props) => props.theme.text};
  padding: 1rem;
  position: relative;
  border: 1px solid ${(props) => props.theme.text};
  @media (max-width: 30rem) {
    padding: 0.5rem;
  }
`;

const commonTitleStyle = `
  display: block;
  text-transform: capitalize;
  color: ${props => props.theme.text};
`;

const SubTitle = styled.span`
  ${commonTitleStyle}
  font-size: ${(props) => props.theme.fontsm};
  font-weight: 400;

  @media (max-width: 40rem) {
    font-size: ${(props) => props.theme.fontsm};
  }
  @media (max-width: 30rem) {
    font-size: ${(props) => props.theme.fontxs};
  }
`;

const Title = styled.span`
  ${commonTitleStyle}
  font-size: ${(props) => props.theme.fontxl};
  margin: 0.5rem 0;
  
  @media (max-width: 40rem) {
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
  }
`;

function RoadmapItem({ title, subTitle }) {
  const containerRef = useRef(null);

  useEffect(() => {
    // Apply GSAP animation with ScrollTrigger
    if (containerRef.current) {
      gsap.fromTo(
        containerRef.current,
        { boxShadow: 'none' },
        {
          boxShadow: '0px 12px 32px rgba(0, 0, 0, 0.6)', // Increased elevation shadow
          scrollTrigger: {
            trigger: containerRef.current,
            start: 'center center',  // Trigger when the element hits the middle of the viewport
            end: 'center top',       // End when it scrolls past
            toggleActions: 'play none none reverse', // Play when in view, reverse when out
          },
        }
      );
    }
  }, []);

  return (
    <Item>
      <ItemContainer ref={containerRef}>
        <Box style={{ backgroundColor: '#FFEA7D' }}>
          <Title style={{ fontWeight: '700' }}>{title}</Title>
          <SubTitle>{subTitle}</SubTitle>
        </Box>
      </ItemContainer>
    </Item>
  );
}

export default memo(RoadmapItem);
